import React, { Component } from 'react';
// import { withRouter } from "react-router-dom";
import './index.less';
import { Input, Icon, Button, message } from 'antd';
import { app_register, app_getCaptcha, app_login } from '../../api/serve';
import UserLayout from '../UserLayout';
import UnChedked from '../../assets/images/logIn_danxuan.png'
import Checked from '../../assets/images/logIn_xuanzhong.png'
import { matchUrl, isContainFrom, setCookie } from '../../utils/utils'
// 手机号
const mobileRule = /(?:^1[3456789]|^9[28])\d{9}$/;
const userNameReg = /^(?!_)(?!.*?_$)[a-zA-Z0-9_\u4e00-\u9fa5]{1,16}$/;

export default class Register extends Component {
    constructor() {
        super();
        this.state = {
            userName: "",
            userPassword: "",
            userrePassword: "",
            phoneNumber: "",
            captchaCode: "",
            isReaded: false
        }

        this.originMark = isContainFrom(window.location.search);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    //监听input中的数据，保存到state中
    changeUsername(e) {
        let uname = e.target.value;
        this.setState({
            userName: uname
        });
        // console.log(this.state.userName);
    }

    onInputBlur() {
        const { userName } = this.state;
        
        if(!userNameReg.test(userName)) {
            message.warn('用户名不符合规范')
        }
    }

    changePassword(e) {
        let upwd = e.target.value;
        this.setState({
            userPassword: upwd
        })
    }

    changePhone(e) {
        let phone = e.target.value;
        this.setState({
            phoneNumber: phone
        })
    }

    getCaptcha = () => {
        const { userName } = this.state;
        if(!userNameReg.test(userName)) {
            message.warn('用户名不符合规范')
            return;
        }

        if (this.state.phoneNumber.trim() === '') {
            message.warn('手机号码不能为空')
            return;
        }

        if (!mobileRule.test(this.state.phoneNumber)) {
            message.warn('请输入正确的手机号码')
            return;
        }
        let count = 59;
            this.setState({ count });
            this.interval = setInterval(() => {
                count -= 1;
                this.setState({ count });
                if (count === 0) {
                    clearInterval(this.interval);
                }
        }, 1000);
        app_getCaptcha(this.state.userName, this.state.phoneNumber).then(res => {
            if(res.data.code === 200) {
                message.success(res.data.msg)
            } else {
                clearInterval(this.interval);
                this.setState({ count: 0})
                message.error(res.data.msg)
            }
        })
    }

    onCaptchaChange = (e) => {
        const captchaCode = e.target.value;
        this.setState({ captchaCode })
    }

    onRead = () => {
        this.setState({
            isReaded: !this.state.isReaded
        })
    }

    handleProtocal() {
        window.open(matchUrl('protocal'), '_blank')
    }


    register() {
        const { userName, userPassword, phoneNumber, captchaCode, isReaded } = this.state;
        const reg = /^(.{0,5}|.{17,}|[^0-9]*|[a-zA-Z0-9]*)$/; // 6-16位 至少含有数字 字母 符号
       
        if(!userNameReg.test(userName)) {
            message.warn('用户名不符合规范')
            return;
        }

        if (this.state.phoneNumber.trim() === '') {
            message.warn('手机号码不能为空')
            return;
        }

        if (!mobileRule.test(this.state.phoneNumber)) {
            message.warn('请输入正确的手机号码')
            return;
        }

        if(this.state.captchaCode.trim() === '') {
            message.warn('验证码不能为空')
            return;
        }
        
        if (this.state.userPassword.trim() === '') {
            message.warn('密码不能为空')
            return;
        }

        if(reg.test(this.state.userPassword)) {
            message.warn('密码不符合要求')
            return
        }

        if(!isReaded) {
            message.warn('你需要阅读并同意相关条款才能使用')
            return
        }

        
        
        app_register(userName, userPassword, phoneNumber, captchaCode).then(res => {
            if(res.data.code === 200) {
                // 如果存在注册来源注册成功需要把来源传给登陆页面
                app_login(userName, userPassword).then(res => {
                    if(res.data.code === 200) {
                        setCookie('ldbp_curToken',res.data.data.access_token, 365);
                        window.location.href = matchUrl('center')
                        
                    }
                })
            } else {
                message.error(res.data.msg)
            }
        })
    }

    render() {
        const { captchaCode, isReaded, count } = this.state;
        return (
            <UserLayout>
                <form action="" className="form-horizontal form-register" onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        this.register()
                    }
                }}>
                    <div className='input_container inputItem'>
                        <Input
                            type='text'
                            prefix={<Icon type="user" style={{ color: '#999', fontSize: '18px' }} />}
                            className="username"
                            placeholder=" 用户名1到16位包含数字、汉字、字母、下划线的组合"
                            name='username'
                            id="uname"
                            ref="uname"
                            onChange={(e) => this.changeUsername(e)}
                            onBlur={() => this.onInputBlur()}    
                        />
                    </div>
                    <div className='input_container inputItem'>
                        <Input
                            type='tel'
                            prefix={<Icon type="mobile" style={{ color: '#999', fontSize: '18px' }} />}
                            className="tel"
                            placeholder="手机号"
                            name='tel'
                            ref="tel"
                            onChange={(e) => this.changePhone(e)} />
                    </div>
                    <div className="input_container inputItem">
                        <div className="input_captcha">
                            <Input
                                type="text"
                                value={captchaCode}
                                prefix={<Icon type="mail" style={{ color: '#999', fontSize: '18px' }} />}
                                placeholder="验证码"
                                onChange={this.onCaptchaChange}
                            />
                        </div>
                        <div className="btn_get_captcha">
                            <Button className="get_captcha" type="button" onClick={this.getCaptcha} disabled={count}>
                                {count ? `${count} s` : '获取短信验证码'}
                            </Button>
                        </div>
                    </div>
                    <div className='input_container inputItem'>
                        <Input
                            type='password'
                            prefix={<Icon type="lock" style={{ color: '#999', fontSize: '18px' }} />}
                            name='pwd'
                            onChange={(e) => this.changePassword(e)}
                            placeholder="6-16位密码，至少包括数字、字母和符号"
                            />
                    </div>
                    <div className="btn_register">
                        <Button className='register' type="button" onClick={() => this.register()}>
                            注&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;册
                        </Button>
                    </div>
                    <div className="protocal">
                        <span className={`checkbox-wrapper checkbox ${ isReaded ? "-checked" : '' }`}>
                            <input type="checkbox" className="wrapped-input" />
                            <span className="checkbox-inner" onClick={this.onRead}>
                                <img src={isReaded ? Checked : UnChedked} />
                            </span>
                            <span onClick={this.handleProtocal}>我已阅读并同意《鲁班开发者平台服务协议》</span>
                        </span>
                    </div>
                    <div className="login_field">
                        <a href={this.originMark ? `${matchUrl('index')}?from` : `${matchUrl('index')}`} className='login_link'>已有账号？<span style={{color: '#f0616f'}}>登录</span></a>
                    </div>
                </form>
            </UserLayout>
        )
    }
}